import { render, staticRenderFns } from "./ReactionTestsNewQuestionModel.vue?vue&type=template&id=48285b67&"
import script from "./ReactionTestsNewQuestionModel.vue?vue&type=script&lang=js&"
export * from "./ReactionTestsNewQuestionModel.vue?vue&type=script&lang=js&"
import style0 from "./ReactionTestsNewQuestionModel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ReactionTestsNewQuestionModel.vue"
export default component.exports